export default {
  async list(context, payload) {
    try {
      const response = await this.$api.call("user.list", payload);
      const responseData = response.data;
      context.commit("mutationUsers", responseData);
      return response;
    } catch (error) {
      context.commit("mutationUsers", []);
      throw error;
    }
  },
  async detail(context, payload) {
    try {
      const response = await this.$api.call("user.detail", payload);
      const responseData = response.data;
      context.commit("mutationUser", responseData);
      return response;
    } catch (error) {
      context.commit("mutationUser", {});
      throw error;
    }
  },
  async create(context, payload) {
    try {
      const response = await this.$api.call("user.create", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async edit(context, payload) {
    try {
      const response = await this.$api.call("user.edit", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async delete(context, payload) {
    try {
      const response = await this.$api.call("user.delete", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async editPassword(context, payload) {
    try {
      const response = await this.$api.call("user.editPassword", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async editProfile(context, payload) {
    try {
      const response = await this.$api.call("user.editProfile", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async toggleLock(context, payload) {
    try {
      const response = await this.$api.call("user.toggleLock", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async partners(context, payload) {
    try {
      const response = await this.$api.call("user.partners", payload);
      const responseData = response.data;
      const dataAlphabetSorted = responseData.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      context.commit("mutationPartners", dataAlphabetSorted);
      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },
  async stores(context, payload) {
    try {
      const response = await this.$api.call("user.stores", payload);
      const responseData = response.data;
      context.commit("mutationStores", responseData);
      return response;
    } catch (error) {
      context.commit("mutationStores", []);
      throw error;
    }
  },
  async areps(context, payload) {
    try {
      const response = await this.$api.call("user.areps", payload);
      const responseData = response.data;
      context.commit("mutationAreps", responseData);
      return response;
    } catch (error) {
      context.commit("mutationAreps", {});
      throw error;
    }
  },
};
